/**
 * EPUB共通UIコンポーネント
 * epub-viewer / continuous-epub-viewer で共有
 */

/**
 * EPUBエラー表示
 */
export function EpubErrorDisplay({ error }: { error: string }) {
  return (
    <div className="fixed w-full h-full flex items-center justify-center bg-[#1a1a1a]">
      <div className="text-red-400">エラー: {error}</div>
    </div>
  )
}

/**
 * EPUBローディング表示
 */
export function EpubLoadingOverlay({ isLoading }: { isLoading: boolean }) {
  if (!isLoading) return null
  return (
    <div className="fixed w-full h-full flex flex-col items-center justify-center bg-[#1a1a1a] z-10">
      <div className="text-gray-400 mb-2">EPUBを読み込み中...</div>
      <div className="w-48 h-2 bg-gray-700 rounded-full mt-2 overflow-hidden">
        <div className="h-full bg-blue-500 rounded-full animate-pulse w-2/3" />
      </div>
    </div>
  )
}
